<template>
  <div class="container-bg">
    <div class="card-feedback" aria-live="polite">
      <div class="feedback feedback-form">
        <div class="actions" v-if="showFeedbackYes && !showFeedbackConfirmationMessage">
          <h2 id="card-title" class="title">Le contenu proposé vous a-t-il été utile ?</h2>
          <div>
            <form>
              <div class="center-content-horizontal">
                <button
                  @click.prevent="submitFormData('Oui')"
                  class="btn-type1 btn-yes"
                  aria-describedby="card-title"
                >
                  <i class="icon-happy-face" aria-hidden="true"></i> Oui
                </button>
                <button
                  @click.prevent="openModal"
                  class="btn-type1 btn-no"
                  aria-describedby="card-title"
                >
                  <i class="icon-sad-face" aria-hidden="true"></i>
                  Non
                </button>
              </div>
              <div v-if="isSubmiting && !displayModal">
                <div class="center-content-horizontal">
                  <div class="loader-wrapper">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                    </div>
                    <p> En cours d'envoi</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="feedback feedback-positive" v-if="!showFeedbackYes || showFeedbackConfirmationMessage">
          <button type="button"
                  class="close-positive"
                  @click="closeFeedBack()">
            <i class="icon-cross-out" aria-hidden="true"></i>
            <span class="sr-only">Fermer</span>
          </button>
          <p class="title" role="status">Merci de votre retour ! <i
            class="icon-happy-face" aria-hidden="true"></i></p>
        </div>
      </div>
    </div>
    <ModalWrapper v-if="displayModal"
                  :is-active="displayModal"
                  @on-close-modal="closeModal"
                  ariaLabelledby="dialog_label"
                  id="feedback"
    >
      <template #header="{ ariaLabelledby }">
        <button type="button"
                @click="closeModal"
                class="btn-close">
          <i class="icon-cross-out" aria-hidden="true"></i>
          <span class="sr-only">Fermer</span>
        </button>
        <h1 :id="ariaLabelledby" class="modal-title">
          <i class="icon-user1" aria-hidden="true"></i>
          <span>Aidez-nous à améliorer Santé.fr</span>
        </h1>
      </template>
      <template #body>
        <div aria-live="polite">
          <div class="explication-modal">
            <div class="modal-form form-row">
              <div v-if="!showFeedbackConfirmationMessage">
                <form @submit.prevent="submitFormData('Non')">
                  <fieldset class="fieldset">
                    <legend>{{ form.research_reason['#title'] }}<span class="mandatory"> (Champ obligatoire)</span>
                    </legend>
                    <div class="form-item form-type-checkboxes form-row">
                      <div class="form-checkboxes">
                        <ul class="resetul">
                          <li v-for="(item, index) in form.research_reason['#options']" class="feedback-cb-item"
                              :key="item.value">
                            <div class="form-item form-type-checkbox checkbox-nude">
                              <input type="checkbox"
                                     :id="`edit-research-reason-${index}`"
                                     :name="`research_reason[${index}]`"
                                     :value="index"
                                     v-model="checkedFeedback">
                              <label :for="`edit-research-reason-${index}`" class="option">{{ item }}</label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </fieldset>
                  <div class="form-item form-type-textfield form-type-textfield-other form-row">
                    <label :for="form.other['#webform_key']">{{ form.other['#title'] }} </label>
                    <input class="text-full form-text "
                           type="text"
                           size="60"
                           maxlength="255"
                           :id="form.other['#webform_key']"
                           :name="form.other['#webform_key']"
                           v-model="other">
                  </div>
                  <div class="form-actions form-wrapper" id="form-actions">
                    <button
                      id="form-actions-bt"
                      name="" class="btn form-submit"
                      type="submit"
                      :value="submitBt"
                      :disabled="(!checkedFeedback.length && !other.length) || isSubmiting"
                    >Envoyer votre retour
                    </button>
                    <div v-if="isSubmiting">
                      <div class="loader-wrapper">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                        </div>
                        <p> En cours d'envoi</p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div v-if="showFeedbackConfirmationMessage">
                <div class="confirmation-message" role="status">
                  Merci de nous aider à améliorer Santé.fr.<br>
                  Nous allons prendre en compte votre retour.
                </div>
                <button class="close-modal" data-dismiss="modal" @click="closeModal">Fermer</button>

              </div>
              <div v-if="showFeedbackErrorMessage">
                <div class="error-message" role="status">
                  Une erreur s'est produite lors de la soumission du formulaire.<br/>
                  Merci de re-essayer ultérieurement.
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </ModalWrapper>
  </div>
</template>

<script>
import { ref } from 'vue';
import ModalWrapper from '@/components/sharedComponents/modals/ModalWrapper.component.vue';

export default ({
  name: 'FeedbackComponent',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    showFeedbackErrorMessage: {
      type: Boolean,
      default: false,
    },
    showFeedbackConfirmationMessage: {
      type: Boolean,
      default: false,
    },
    showFeedbackYes: {
      type: Boolean,
      default: true,
    },
    isSubmiting: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalWrapper,
  },
  emits: ['feedback-close', 'reset-form'],
  setup(props, { emit }) {
    const submitInfoYes = ref({});
    const displayModal = ref(false);
    const checkedFeedback = ref([]);
    const other = ref('');
    const submitInfo = ref({});

    function closeFeedBack() {
      emit('feedback-close');
    }

    function openModal() {
      displayModal.value = !displayModal.value;
      emit('reset-form');
    }

    function closeModal() {
      other.value = '';
      checkedFeedback.value = [];
      displayModal.value = !displayModal.value;
    }

    function submitFormData(helpfull) {
      submitInfo.value = {
        helpful: helpfull,
        research_reason: checkedFeedback.value,
        other: other.value,
        url_content: window.location.pathname,
        form_id: props.form.actions['#webform'],
      };
      emit('onSubmitFeedback', submitInfo.value);
    }

    return {
      submitInfoYes,
      displayModal,
      checkedFeedback,
      other,
      submitInfo,
      closeFeedBack,
      openModal,
      closeModal,
      submitFormData,
    };
  },
});

</script>

<style lang="scss">
.pagesinformervuejs {
  .search-result-wrapper {
    .search-result-content {
      .list-blocks {
        .card-water-drop {
          h2 {
            text-align: center;
            text-transform: none;
            font-weight: 300;
            font-size: 1.4em;
            line-height: 1.4em;
            padding-right: 0;
            margin-bottom: 20px;

            &:after {
              display: none;
            }
          }
        }
      }
    }
  }

  .feedback-positive {
    p.title {
      @media(max-width: 768px) {
        line-height: 2 !important;
      }

    }
  }
}

</style>
